/**
 * Zentrale SEO- und Unternehmensdaten für Marmoris
 * Verwendung: Meta-Tags, JSON-LD, Canonical URLs, interne Links
 */
export const SITE = {
  name: "Marmoris",
  nameFull: "Marmoris Studio",
  url: "https://www.marmoris.at",
  defaultTitle: "Marmoris – Digital Marketing & Social Media Agentur | Kärnten & Österreich",
  defaultDescription:
    "Digital Marketing und Social Media Marketing für Unternehmen in Österreich. Digitale Vermarktung, Online-Präsenz und Social Media Betreuung aus Wolfsberg, Kärnten.",
  locale: "de_AT",
  language: "de",
  region: "Kärnten",
  country: "Österreich",
  address: {
    street: "Weinleiten 7",
    postalCode: "9400",
    city: "Wolfsberg",
    region: "Kärnten",
    country: "Österreich",
  },
  contact: {
    phone: "+43 664 9992990",
    email: "office@marmoris.at",
  },
  social: {},
  services: [
    "Digital Marketing",
    "Social Media Marketing",
    "Digitale Vermarktung",
    "Online-Marketing",
    "Websites",
    "Branding",
    "Corporate Design",
  ],
  areas: [
    "Wolfsberg",
    "Klagenfurt",
    "Villach",
    "Graz",
    "Kärnten",
    "Steiermark",
    "Österreich",
  ],
};

/** Alle Routen für Sitemap und interne Links */
export const ROUTES = {
  home: "/",
  impressum: "/impressum",
  datenschutz: "/datenschutz",
  // Primary: Marketing
  digitaleVermarktung: "/digitale-vermarktung",
  socialMediaMarketing: "/social-media-marketing",
  onlineMarketingUnternehmen: "/online-marketing-fuer-unternehmen",
  digitaleMarkenpraesenz: "/digitale-markenpraesenz",
  // Supporting: Websites & Branding
  websitesUnternehmen: "/websites-fuer-unternehmen",
  serviceWebdesign: "/webdesign",
  serviceBranding: "/branding",
  serviceCorporateDesign: "/corporate-design",
  serviceDigitalStrategy: "/digitale-strategie",
  serviceRelaunch: "/website-relaunch",
  // Location (existing + marketing-focused)
  locationAustria: "/webdesign-agentur-oesterreich",
  locationKaernten: "/webdesign-agentur-kaernten",
  locationKlagenfurt: "/webdesign-agentur-klagenfurt",
  locationVillach: "/webdesign-agentur-villach",
  locationGraz: "/webdesign-agentur-graz",
  locationWolfsberg: "/webdesign-agentur-wolfsberg",
  marketingKaernten: "/marketing-agentur-kaernten",
  socialMediaKlagenfurt: "/social-media-agentur-klagenfurt",
  onlineMarketingGraz: "/online-marketing-graz",
  digitaleVermarktungWolfsberg: "/digitale-vermarktung-wolfsberg",
  marketingVillach: "/marketing-agentur-villach",
  marketingAustria: "/marketing-agentur-oesterreich",
  // Branchen
  industryAerzte: "/webdesign-fuer-aerzte",
  industryRestaurants: "/webdesign-fuer-restaurants",
  industryHandwerker: "/webdesign-fuer-handwerker",
  industryUnternehmen: "/webdesign-fuer-unternehmen",
  // Bildungsinhalt
  costWebdesign: "/webdesign-kosten-oesterreich",
  costBranding: "/branding-kosten-oesterreich",
  costSocialMedia: "/social-media-betreuung-kosten-oesterreich",
};

export const canonical = (path) => (path.startsWith("http") ? path : `${SITE.url}${path === "/" ? "" : path}`);
